<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="7.4412mm" height="3.0357mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 31322 12778"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_3">
    <g id="_120080712">
     <path class="fil0" d="M5545 6510c0,1112 888,1688 2050,1688l16153 0c2874,0 2525,-3376 242,-3376l-16636 0c-1004,0 -1809,720 -1809,1688z"/>
     <path class="fil0" d="M23626 1447c0,1825 2968,3432 3978,4942l-3238 3271c-1455,1149 -1051,3118 948,3118 805,0 1832,-1282 2561,-2020 340,-344 504,-424 844,-723 410,-362 1965,-1871 2227,-2354 464,-856 495,-1434 111,-2333 -171,-400 -3402,-3670 -3784,-4052 -870,-870 -992,-1296 -2200,-1296 -724,0 -1447,722 -1447,1447z"/>
     <path class="fil0" d="M0 6389c0,1483 1732,2754 2562,3587 569,571 1058,935 1627,1506 869,872 996,1296 2200,1296 625,0 2706,-1204 410,-3303l-253 -228c-244,-223 -379,-367 -609,-597 -575,-577 -1814,-1684 -2200,-2261 1011,-1510 3978,-3117 3978,-4942 0,-910 -768,-1447 -1808,-1447 -765,0 -1346,804 -1778,1236l-3014 3134c-546,544 -1115,1150 -1115,2019z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Arrows',
};
</script>

<style scoped>
.fil0 {fill:#666666}
</style>
